/**
 * Restituisce la stringa passato come parametro con la prima lettera maiuscola
 * @param {string} string
 * @return {string} 
 */
function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
  